export default __webpack_public_path__ + "static/media/feather _ magaphone.63a73407.svg";